// extracted by mini-css-extract-plugin
export default {"wrapper":"CpIWZ5IpGp","header":"F41j51BY7b","title-message":"_3ISe0Oi-fg","titleMessage":"_3ISe0Oi-fg","change-location":"_1zmzdRdyaW","changeLocation":"_1zmzdRdyaW","map-disabled":"_3Vrt28M9Ox","mapDisabled":"_3Vrt28M9Ox"};
    if(module.hot) {
      // 1625219529214
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  